document.addEventListener("DOMContentLoaded", () => {
    try {
        const selector = ".text-marquee, .marquee-text";
        const defaultSpeed = 96;
        const deadZone = 0.16;
        const acceleration = 7;
        const dragResumeDelay = 900;
        const maxCopies = 40;
        const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        const canHover = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
        const isTouchLike = !canHover;
        const canDrag = "PointerEvent" in window;
        const isDiviVisualBuilder =
            document.body.classList.contains("et-fb") ||
            document.body.classList.contains("et-fb-root-ancestor") ||
            document.querySelector("#et-fb-app, .et-fb-app, .et-fb-root-ancestor") !== null;

        if (isDiviVisualBuilder) return;

        const elements = Array.from(document.querySelectorAll(selector));

        if (!elements.length) return;

        const getTextTarget = (element) => {
            if (!element.classList.contains("et_pb_module")) return element;

            return element.querySelector(".et_pb_text_inner") || element;
        };

        const getNumber = (value, fallback) => {
            const number = Number.parseFloat(value);

            return Number.isFinite(number) ? number : fallback;
        };

        const wrapPosition = (value, max) => ((value % max) + max) % max;

        const renderTrack = (state) => {
            state.track.style.transform = `translate3d(${-state.position}px, 0, 0)`;
        };

        const sanitizeVisualItem = (item) => {
            item.querySelectorAll("[id]").forEach((node) => node.removeAttribute("id"));
            item.querySelectorAll("script, style, noscript").forEach((node) => node.remove());
        };

        const createItem = (sourceHTML) => {
            const item = document.createElement("div");

            item.className = "text-marquee__item";
            item.setAttribute("aria-hidden", "true");
            item.innerHTML = sourceHTML;
            sanitizeVisualItem(item);

            return item;
        };

        const clearElement = (element) => {
            while (element.firstChild) {
                element.removeChild(element.firstChild);
            }
        };

        const preparedElements = elements.map((element) => {
            const target = getTextTarget(element);

            if (!target || target.querySelector(".text-marquee__track")) return null;

            const sourceHTML = target.innerHTML.trim();
            const sourceText = target.textContent.replace(/\s+/g, " ").trim();

            if (!sourceHTML || !sourceText) return null;

            const configuredSpeed = getNumber(element.dataset.marqueeSpeed, defaultSpeed);
            const speed = Math.max(24, isTouchLike ? configuredSpeed * 0.68 : configuredSpeed);
            const hoverSpeed = Math.max(speed, getNumber(element.dataset.marqueeHoverSpeed, speed * 2.6));
            const srText = document.createElement("span");
            const viewport = document.createElement("div");
            const track = document.createElement("div");
            const firstItem = createItem(sourceHTML);
            const state = {
                currentSpeed: reduceMotion ? 0 : speed,
                distance: 0,
                isDragging: false,
                isPausedAfterDrag: false,
                position: 0,
                speed,
                targetSpeed: reduceMotion ? 0 : speed,
                track,
            };

            srText.className = "text-marquee__sr";
            srText.textContent = sourceText;
            viewport.className = "text-marquee__viewport";
            track.className = "text-marquee__track";

            track.appendChild(firstItem);
            viewport.appendChild(track);
            clearElement(target);
            target.appendChild(srText);
            target.appendChild(viewport);
            element.classList.add("is-marquee-ready");

            const layout = () => {
                const viewportWidth = viewport.getBoundingClientRect().width;
                const itemWidth = firstItem.getBoundingClientRect().width;

                if (!viewportWidth || !itemWidth) return;

                const copyCount = Math.min(
                    maxCopies,
                    Math.max(2, Math.ceil(viewportWidth / itemWidth) + 2),
                );

                while (track.children.length < copyCount) {
                    track.appendChild(createItem(sourceHTML));
                }

                while (track.children.length > copyCount) {
                    track.removeChild(track.lastElementChild);
                }

                state.distance = itemWidth;
                state.position = wrapPosition(state.position, itemWidth);
                renderTrack(state);
            };

            const getHoverTargetSpeed = (clientX) => {
                const rect = viewport.getBoundingClientRect();
                const pointerX = clientX - rect.left;
                const normalized = Math.max(-1, Math.min(1, (pointerX / rect.width) * 2 - 1));
                const magnitude = Math.abs(normalized);

                if (magnitude <= deadZone) return 0;

                const edgeStrength = (magnitude - deadZone) / (1 - deadZone);
                const easedStrength = edgeStrength * edgeStrength;

                return Math.sign(normalized) * hoverSpeed * easedStrength;
            };

            if (canHover && !reduceMotion) {
                const updatePointerSpeed = (event) => {
                    if (state.isDragging || state.isPausedAfterDrag) return;

                    state.targetSpeed = getHoverTargetSpeed(event.clientX);
                };

                viewport.addEventListener("pointerenter", updatePointerSpeed);
                viewport.addEventListener("pointermove", updatePointerSpeed);
                viewport.addEventListener("pointerleave", () => {
                    if (state.isDragging || state.isPausedAfterDrag) return;

                    state.targetSpeed = speed;
                });
            }

            if (canDrag && !reduceMotion) {
                let pointerId = null;
                let startX = 0;
                let startPosition = 0;
                let hasDragged = false;
                let resumeTimer = null;

                const resumeAfterDrag = () => {
                    if (resumeTimer) {
                        window.clearTimeout(resumeTimer);
                    }

                    state.isPausedAfterDrag = true;
                    state.currentSpeed = 0;
                    state.targetSpeed = 0;

                    resumeTimer = window.setTimeout(() => {
                        state.isPausedAfterDrag = false;
                        state.targetSpeed = speed;
                        resumeTimer = null;
                    }, dragResumeDelay);
                };

                viewport.addEventListener("pointerdown", (event) => {
                    if (event.isPrimary === false || !state.distance) return;
                    if (event.pointerType === "mouse" && event.button !== 0) return;

                    if (resumeTimer) {
                        window.clearTimeout(resumeTimer);
                        resumeTimer = null;
                    }

                    pointerId = event.pointerId;
                    startX = event.clientX;
                    startPosition = state.position;
                    hasDragged = false;
                    state.isDragging = true;
                    state.isPausedAfterDrag = false;
                    state.currentSpeed = 0;
                    state.targetSpeed = 0;

                    if (viewport.setPointerCapture) {
                        viewport.setPointerCapture(pointerId);
                    }

                    element.classList.add("is-marquee-dragging");
                });

                viewport.addEventListener("pointermove", (event) => {
                    if (event.pointerId !== pointerId || !state.distance) return;

                    const deltaX = event.clientX - startX;

                    if (Math.abs(deltaX) > 6) {
                        hasDragged = true;
                    }

                    state.position = wrapPosition(startPosition - deltaX, state.distance);
                    renderTrack(state);
                });

                const endDragControl = (event) => {
                    if (event.pointerId !== pointerId) return;

                    if (viewport.hasPointerCapture && viewport.hasPointerCapture(pointerId)) {
                        viewport.releasePointerCapture(pointerId);
                    }

                    state.isDragging = false;
                    pointerId = null;
                    element.classList.remove("is-marquee-dragging");

                    if (hasDragged) {
                        resumeAfterDrag();
                    } else {
                        state.targetSpeed = canHover ? getHoverTargetSpeed(event.clientX) : speed;
                    }
                };

                viewport.addEventListener("pointerup", endDragControl);
                viewport.addEventListener("pointercancel", (event) => {
                    if (event.pointerId !== pointerId) return;

                    state.isDragging = false;
                    pointerId = null;
                    element.classList.remove("is-marquee-dragging");
                    resumeAfterDrag();
                });
            }

            return { layout, state, target };
        }).filter(Boolean);

        if (!preparedElements.length) return;

        let animationFrame = null;
        const layoutAll = () => {
            if (animationFrame) {
                window.cancelAnimationFrame(animationFrame);
            }

            animationFrame = window.requestAnimationFrame(() => {
                preparedElements.forEach(({ layout }) => layout());
                animationFrame = null;
            });
        };

        const resizeObserver = "ResizeObserver" in window
            ? new ResizeObserver(layoutAll)
            : null;

        preparedElements.forEach(({ target, layout }) => {
            layout();

            if (resizeObserver) {
                resizeObserver.observe(target);
            }
        });

        window.addEventListener("resize", layoutAll, { passive: true });

        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(layoutAll).catch(() => {});
        }

        if (reduceMotion) return;

        let previousTime = null;

        const tick = (time) => {
            if (previousTime === null) {
                previousTime = time;
            }

            const delta = Math.min(64, time - previousTime) / 1000;
            previousTime = time;

            preparedElements.forEach(({ state }) => {
                if (!state.distance || state.isDragging) return;

                const ease = Math.min(1, delta * acceleration);

                state.currentSpeed += (state.targetSpeed - state.currentSpeed) * ease;

                if (Math.abs(state.currentSpeed) < 0.15 && Math.abs(state.targetSpeed) < 0.15) {
                    state.currentSpeed = 0;
                }

                state.position = wrapPosition(state.position + state.currentSpeed * delta, state.distance);
                renderTrack(state);
            });

            window.requestAnimationFrame(tick);
        };

        window.requestAnimationFrame(tick);
    } catch (error) {
        console.error("Text marquee could not be initialized.", error);
    }
});
